import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import Button from 'components/Button'
import { ValidationProposalModalFooterButtons, ValidationProposalModalText } from '../style'

const SubmitConfirmationModal = ({ completedSections = [], onBack, onSubmit, monitoring }) => {
  const [isLastStep, setIsLastStep] = useState(false)

  const allSections = []
  if (!monitoring || monitoring.state_evaluation === true) allSections.push('State')
  if (!monitoring || monitoring.pressure_evaluation === true) allSections.push('Pressure')
  if (!monitoring || monitoring.response_evaluation === true) allSections.push('Response')
  if (allSections.length === 0) {
    allSections.push('State', 'Pressure', 'Response')
  }

  const uncompletedSections = allSections.filter((section) => !completedSections.includes(section))
  const hasIncomplete = uncompletedSections.length > 0

  const handleNext = () => {
    if (!hasIncomplete || isLastStep) {
      onSubmit()
    } else {
      setIsLastStep(true)
    }
  }

  const renderMessage = () => {
    if (hasIncomplete && !isLastStep) {
      return (
        <FormattedMessage
          id="confirmationIncomplete"
          values={{
            sections: completedSections.join(' and ')
          }}
        />
      )
    }
    return <FormattedMessage id="confirmationFinal" />
  }

  return (
    <div>
      <ValidationProposalModalText>{renderMessage()}</ValidationProposalModalText>

      <ValidationProposalModalFooterButtons>
        <Button type="secondary" onClick={onBack}>
          <FormattedMessage id="goBack" />
        </Button>
        <Button type="primary" onClick={handleNext}>
          <FormattedMessage id="submit" />
        </Button>
      </ValidationProposalModalFooterButtons>
    </div>
  )
}

export default SubmitConfirmationModal
